import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { TaxaCrescimentoComponent } from './taxa-crescimento.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TaxaCrescimentoComponent
    ],
    exports: [
        TaxaCrescimentoComponent
    ]
})
export class TaxaCrescimentoModule { }
